export const calculateScores = (answers, quizType = 'focused') => {
  const scores = {
    cerebrumRoot: 0,
    cerebrumLeaf: 0,
    cerebrumFlower: 0,
    limbicSystem: 0,
    brainstem: 0
  };

  if (quizType === 'comprehensive') {
    // Cerebrum Root - foundational skills
    const rootQuestions = [1, 2, 3, 5, 13, 14];
    let rootSum = 0; let rootCount = 0;
    rootQuestions.forEach(qId => {
      if (answers[qId] !== undefined) {
        let score = answers[qId];
        if ([1, 2, 13].includes(qId)) score = 5 - score;
        rootSum += score; rootCount++;
      }
    });
    scores.cerebrumRoot = rootCount > 0 ? rootSum / rootCount : 0;

    // Cerebrum Leaf - functional skills
    const leafQuestions = [4, 6, 7, 8, 15, 20];
    let leafSum = 0; let leafCount = 0;
    leafQuestions.forEach(qId => {
      if (answers[qId] !== undefined) {
        let score = answers[qId];
        if ([7].includes(qId)) score = 5 - score;
        leafSum += score; leafCount++;
      }
    });
    scores.cerebrumLeaf = leafCount > 0 ? leafSum / leafCount : 0;

    // Cerebrum Flower - complex skills
    const flowerQuestions = [10, 11, 16, 19];
    let flowerSum = 0; let flowerCount = 0;
    flowerQuestions.forEach(qId => {
      if (answers[qId] !== undefined) {
        let score = answers[qId];
        if ([16].includes(qId)) score = 5 - score;
        flowerSum += score; flowerCount++;
      }
    });
    scores.cerebrumFlower = flowerCount > 0 ? flowerSum / flowerCount : 0;

    // Limbic System
    const limbicQuestions = [9, 17];
    let limbicSum = 0; let limbicCount = 0;
    limbicQuestions.forEach(qId => {
      if (answers[qId] !== undefined) {
        let score = answers[qId];
        if ([17].includes(qId)) score = 5 - score;
        limbicSum += score; limbicCount++;
      }
    });
    scores.limbicSystem = limbicCount > 0 ? limbicSum / limbicCount : 0;

    // Brainstem
    const brainstemQuestions = [12, 18];
    let brainstemSum = 0; let brainstemCount = 0;
    brainstemQuestions.forEach(qId => {
      if (answers[qId] !== undefined) {
        brainstemSum += answers[qId];
        brainstemCount++;
      }
    });
    scores.brainstem = brainstemCount > 0 ? brainstemSum / brainstemCount : 0;

  } else {
    // Focused quiz scoring
    const rootQuestions = [1, 2, 3];
    let rootSum = 0; let rootCount = 0;
    rootQuestions.forEach(qId => {
      if (answers[qId] !== undefined) {
        let score = answers[qId];
        if ([1, 2].includes(qId)) score = 5 - score;
        rootSum += score; rootCount++;
      }
    });
    scores.cerebrumRoot = rootCount > 0 ? rootSum / rootCount : 0;

    const leafQuestions = [4, 6, 7, 8];
    let leafSum = 0; let leafCount = 0;
    leafQuestions.forEach(qId => {
      if (answers[qId] !== undefined) {
        let score = answers[qId];
        if ([7].includes(qId)) score = 5 - score;
        leafSum += score; leafCount++;
      }
    });
    scores.cerebrumLeaf = leafCount > 0 ? leafSum / leafCount : 0;

    const flowerQuestions = [10, 11];
    let flowerSum = 0; let flowerCount = 0;
    flowerQuestions.forEach(qId => {
      if (answers[qId] !== undefined) {
        flowerSum += answers[qId];
        flowerCount++;
      }
    });
    scores.cerebrumFlower = flowerCount > 0 ? flowerSum / flowerCount : 0;

    if (answers[9] !== undefined) {
      scores.limbicSystem = answers[9];
    }

    if (answers[12] !== undefined) {
      scores.brainstem = answers[12];
    }
  }

  return scores;
};

export const generateRecommendation = (scores) => {
  const categoryScores = Object.values(scores);
  const hasSignificantScore = categoryScores.some(score => score >= 3.0);
  const hasModerateScore = categoryScores.some(score => score >= 2.5);
  const averageScore = categoryScores.reduce((a, b) => a + b, 0) / categoryScores.length;

  if (hasSignificantScore) {
    return "Further evaluation recommended - Your results indicate significant challenges in key cognitive domains. We highly recommend taking the comprehensive Brain Map to learn more and receive personalized strategies.";
  } else if (hasModerateScore || averageScore >= 2.0) {
    return "Further evaluation recommended - Your results suggest areas of concern that could benefit from professional guidance. Taking the Brain Map can help develop targeted strategies for these specific domains.";
  } else {
    return "Within typical range - Most areas appear to be functioning well, though everyone can benefit from continued cognitive skill development and an understanding of their unique brain map.";
  }
};